export { default } from './ErrorBoundary';
export type { ErrorBoundaryProps, ErrorBoundaryClassKey } from './ErrorBoundary.types';
